import { Breakpoint, Button, ButtonType, UiComponentSize } from '@altibox/design-system-component-lib';
import React, { FunctionComponent } from 'react';

import { Link } from 'app/components/link';
import { config } from 'app/config/config';
import { i18n } from 'app/i18n';
import { OrderStep } from 'app/pages/order/redux/model/order-step';
import { I18nUtils } from 'app/utils/i18n-utils';
import { submitShoppingCartActionCreator } from 'app/pages/order/redux/action-creators/submit-shopping-cart-action-creator';
import { useDispatchRequestAndHandleErrors } from 'app/hooks/use-dispatch-request-and-handle-errors';
import { useGoToStep } from 'app/hooks/use-go-to-step';

import { ProductInformationCard } from './product-information/product-information-card';
import { DeliveryInformationCard } from './delivery-information/delivery-information-card';
import { PaymentInformationCard } from './payment-information/payment-information-card';
import {
    StyledButtonContainer,
    StyledContainer,
    StyledDisclaimer,
    StyledHeading,
    StyledNote,
    StyledTerms,
} from './summary-page-content.styled';

export const SummaryPageContent: FunctionComponent = () => {
    const submitOrder = useDispatchRequestAndHandleErrors();
    const goToStep = useGoToStep();

    const handleButtonClick = (): void => {
        submitOrder(submitShoppingCartActionCreator());
        goToStep(OrderStep.SUCCESS);
    };

    const renderTermsLink = (): React.ReactNode => (
        <Link variant="paragraph3" maxBreakpoint={Breakpoint.TABLET} href={config.TERMS_PAGE_URL}>
            {i18n.page.summary.linkToTerms}
        </Link>
    );

    return (
        <StyledContainer>
            <StyledHeading component="h1" variant="headline2">
                {i18n.page.summary.title}
            </StyledHeading>
            <ProductInformationCard />
            <PaymentInformationCard />
            <DeliveryInformationCard />
            <StyledNote component="p" variant="paragraph3" maxBreakpoint={Breakpoint.TABLET}>
                {i18n.page.summary.note}
            </StyledNote>
            <StyledButtonContainer>
                <Button
                    buttonType={ButtonType.PRIMARY_A}
                    uiComponentSize={UiComponentSize.LARGE}
                    onClick={handleButtonClick}
                >
                    {i18n.page.summary.submitButton}
                </Button>
            </StyledButtonContainer>
            <StyledTerms component="p" variant="paragraph3" maxBreakpoint={Breakpoint.TABLET}>
                {I18nUtils.richMessage(i18n.page.summary.terms, { link: renderTermsLink() })}
            </StyledTerms>
            <StyledDisclaimer component="p" variant="paragraph3" maxBreakpoint={Breakpoint.TABLET}>
                {i18n.page.summary.disclaimer}
            </StyledDisclaimer>
        </StyledContainer>
    );
};
